<template>
    <el-dialog :visible.sync="show"
        :title="$t('privateNetInstance.unBindTitle')"
        :close-on-click-modal="false"
        :before-close="handleClose"
        size="tiny"
        class="del-root">
        <p>{{ $t('privateNetInstance.sureUnBindTip', [publicIp]) }}</p>
        <div slot="footer" class="dialog-footer">
            <el-button @click="cancelUnbind">{{ $t('privateNetInstance.cancel') }}</el-button>
            <el-button @click="sureUnbind" type="primary">{{ $t('privateNetInstance.sure') }}</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: 'UnBindEip',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        publicIp: {
            type: String,
            default: ''
        },
        elasticIpId: {
            type: String,
            default: ''
        },
        instanceId: {
            type: String,
            default: ''
        },
        region: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            show: false
        };
    },
    watch: {
        visible(newVal) {
            this.show = newVal;
            console.log(this.vpcName)
        }
    },
    methods: {
        handleClose() {
            this.show = false;
            this.$emit('update:visible', false);
        },
        cancelUnbind() {
            this.handleClose();
        },
        sureUnbind() {
            const params = {
                region: this.region,
                instanceId: this.instanceId,
                elasticIpId: this.elasticIpId
            };
            Ajax.put('/api/cps/disassociateElasticIp', params)
            .then((res) => {
              // this.$message.success(this.$t('privateNetInstance.operateSuccess'));
            })
            .catch(async (err) => {
                const { response } = err.data;
                try {
                    const json = await response.json();
                    this.$message.error(json.errmsg);
                } catch (ex) {
                    console.log(ex);
                }
            })
            .finally(() => {
                this.handleClose();
                this.$emit('refresh');
            });
        }
    },
};
</script>

<style scoped lang="scss">
    .del-root {
        p {
            text-align: left;
            margin: 12px;
            line-height: 1.5;
            color: #212121;
            word-break: break-all;
            font-size: 14px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/common/UnBindEip.vue